import axios from "axios";
import { OriginRegionViewModel } from "../ViewModel/OriginRegionViewModel";
import { GetQueryString } from "../../Utils/GetQueryString";
import { combinedUrls } from "../../URL/functions";
import { projectUrls } from "../../URL/ApplicationUrls";

export async function getOriginRegionByRoutingWithEquipment(
  supplierRoutingGsdb: string | undefined,
  destinationRoutingGsdb: string | undefined,
  equiment: string | undefined,
  startDateDisplay: string
) {
  const params: any = {
    supplierGsdb: supplierRoutingGsdb,
    destinationGsdb: destinationRoutingGsdb,
    equipment: equiment,
    projectStartDateString: startDateDisplay,
  };

  const query = GetQueryString(params);

  const baseUrl = combinedUrls(projectUrls.base.apiUrl, "/OriginRegionByRoutingWithEquipment");
  const url = `${baseUrl}?${query}`;

  const response = await axios.get(url);
  if (response.status === 204) {
    return undefined;
  }
  if (response.status !== 200) {
    throw new Error("Network response was not ok");
  }

  return response.data as OriginRegionViewModel;
}
